import { render } from "./OrderQuery.vue?vue&type=template&id=4d7e4799&scoped=true"
import script from "./OrderQuery.vue?vue&type=script&lang=js"
export * from "./OrderQuery.vue?vue&type=script&lang=js"

import "./OrderQuery.vue?vue&type=style&index=0&id=4d7e4799&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7e4799"]])

export default __exports__